/**
 * Created by portiz on 2/13/19.
 */
import React from 'react';
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Form
} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import NavbarDesktop from './navbar-employee/navbar-desktop';
import NavbarMobile from './navbar-employee/navbar-mobile';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMoneyCheck} from '@fortawesome/free-solid-svg-icons';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';
import PlanDataTable from '../datatables/plan-data-table';
import ModalPlans from '../modals/modal-plans';

// This is the item list
class PlansSearch extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            subscriptionsData: null,
            navbarMobile: false,
            didMount: false,
            planId: null,
            loading: false,
            showModal: false,
            showPlansModal: false,
            propsModal: null,
            isEdit: true,
            redoSearch: false
        };
        this.props.addTranslation(global);

        this.handlePlanSelection = this.handlePlanSelection.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.toggleUpdateModal = this.toggleUpdateModal.bind(this);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.setState({didMount: true});
        this.resize();
    }

    /**
     * Toogles alert modal
     */
    toggleAlertModal(){
        this.setState({showModal: false});
    }

    /** Toggle the update plan modal **/
    toggleUpdateModal(e){
        this.setState({
            showPlansModal: e,
            redoSearch: true
        });
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    handlePlanSelection(e) {
        this.setState({
            planId: e.Id,
            showPlansModal: true
        });
    }

    /**
     * Renders the main page
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}

                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faMoneyCheck}/>{' '}
                            <Translate id="plan.plan-search"/>
                        </h2>
                        <small className="white-text">
                            <Translate id="plan.plan-search-instructions"/>
                        </small>
                        <hr/>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-white">
                                    <CardBody>
                                        <Form>
                                            <PlanDataTable redoSearch={this.state.redoSearch} updateParent={this.handlePlanSelection}/>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <hr/>
                    </Container>
                </div>
                <Footer/>
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ?
                    <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
                {this.state.showPlansModal ?
                    <ModalPlans planId={this.state.planId} isEdit={this.state.isEdit}
                                visible={this.state.showPlansModal} updateParent={this.toggleUpdateModal}/> : null
                }
            </div>
        )
    };
}

export default withLocalize(PlansSearch);